<template>
  <lt-focus-group-collection>
    <lt-roving-focus-group-impl v-bind="$attrs">
      <slot />
    </lt-roving-focus-group-impl>
  </lt-focus-group-collection>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import LtRovingFocusGroupImpl from './roving-focus-group-impl.vue'
import { LtCollection as LtFocusGroupCollection } from './roving-focus-group'

export default defineComponent({
  name: 'LtRovingFocusGroup',
  components: {
    LtFocusGroupCollection,
    LtRovingFocusGroupImpl,
  },
})
</script>
